import {lazy} from 'react';

export const AboutAsync = lazy(() =>
    import('./About')
);
